export default {
  GET_DEALER: (state) => state.dealer,
  GET_DEALERS: (state) => state.dealers,
};
